import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "./index.css";

import toast from "react-hot-toast";
import { PrimaryButton, SecondaryButton } from "../../StyledCss/styledbtn";
import FailureView from "../FailureView";
import LoadingView from "../LoadingView";
import { getPendingLeaves, updateLeave } from "../../api/services/hroneApi";
import LeaveRejectForm from "../LeaveRejectForm/leaveRejectForm";
import PopupModal from "../PopupModal";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";
const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const LeaveRequestsRoute = () => {
  const [leavesReqData, setLeavesReqData] = useState([]);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  const [rejectClicked, setReject] = useState(false);
  const [rowData, setRowData] = useState({});

  const [startMonth, setStartMonth] = useState(new Date());
  const [endMonth, setEndMonth] = useState(new Date());

  // This component previously had no permission check of its own — access was
  // enforced only by the parent "Requests" tab being hidden. Added explicitly
  // here too, per the migration plan, so Approve/Reject are protected even if
  // this component is ever reached another way.
  const { hasPermission } = usePermissions();
  const canApprove = hasPermission(FEATURE_CODES.LEAVE_REQUESTS_APPROVE);
  const canReject = hasPermission(FEATURE_CODES.LEAVE_REQUESTS_REJECT);

  const formattedStartMonth = format(startMonth, "yyyy-MM");
  const formattedEndMonth = format(endMonth, "yyyy-MM");
  const notifyApproved = (type) => {
    toast.success(`${type} Approved`);
  };
  const notifyRejected = (type) => {
    toast.success(`${type} Rejected`);
  };

  const notifyFailure = () => toast.error("something went wrong");

  useEffect(() => {
    getLeavesReqData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startMonth, endMonth]);

  const getLeavesReqData = async () => {
    setApiStatus(apiStatusConstants.inProgress);

    try {
      const response = await getPendingLeaves({
        start_month: formattedStartMonth,
        end_month: formattedEndMonth,
      });
      if (response.ok) {
        const pendingLeaves = await response.json();
        const data = pendingLeaves.data;
       const camelCaseData = await data.map((eachItem) =>
                  convertKeysToCamelCase(eachItem)
                );
        setLeavesReqData(camelCaseData);       
         setApiStatus(apiStatusConstants.success);
      } else {
        setApiStatus(apiStatusConstants.failure);
      }
    } catch (e) {
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const onClickApprove = (params) => {
    sendAcceptedStatus(params);
  };

  const sendAcceptedStatus = async (params) => {
    const empLeaveId = params.data.leaveId;
    const leaveStatus = "Approved";
    const response = await updateLeave(leaveStatus, empLeaveId, "");
    try {
      if (response.status === 200) {
        notifyApproved(params.data.requestType);
        getLeavesReqData();
      } else {
        notifyFailure();
      }
    } catch (error) {
      notifyFailure();
    }
  };

  const onClickReject = (params) => {
    const rowData = params.data;
    setRowData({ ...rowData, status: "Rejected" });
    setReject(true);
  };

  const onClickClose = () => {
    setReject(false);
  };

  const pendingLeavescolumns = [
    {
      headerName: "EMP ID",
      field: "employeeId",
      width: 120,
      pinned: "left",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "NAME",
      field: "fullName",
      filter: true,
      sortable: true,
      pinned: "left",
      floatingFilter: true,
      tooltipField: "fullName",
      suppressMenu: true
    },
    {
      headerName: "START DATE",
      field: "startDate",
      pinned: "left",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "END DATE",
      field: "endDate",
      floatingFilter: true,
      filter: true,
      pinned: "left",
      suppressMenu: true
    },
    {
      headerName: "REQUEST TYPE",
      field: "requestType",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    { headerName: "DAYS", field: "days", floatingFilter: true, filter: true, suppressMenu: true },
    {
      headerName: "REASON",
      field: "leaveReason",
      tooltipField: "leaveReason",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "LEAVES UTILIZED",
      field: "leavesUtilized",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },

    ...(canApprove
      ? [
          {
            headerName: "APPROVE",
            suppressMenu: true,
            cellRenderer: (params) => (
              <PrimaryButton
                disabled={params.data.status === "Approved"}
                className="approve-btn d-flex  justify-content-center align-items-center"
                onClick={() => onClickApprove(params)}
              >
                {params.data.status === "Approved" ? "Approved" : "Approve"}
              </PrimaryButton>
            ),
          },
        ]
      : []),

    ...(canReject
      ? [
          {
            headerName: "REJECT",
            suppressMenu: true,
            cellRenderer: (params) => (
              <SecondaryButton
                disabled={params.data.status === "Rejected"}
                className="reject-btn d-flex  justify-content-center align-items-center"
                onClick={() => onClickReject(params)}
              >
                {params.data.status === "Rejected" ? "Rejected" : "Reject"}
              </SecondaryButton>
            ),
          },
        ]
      : []),
    // {
    //   headerName: "CANCEL",
    //   cellRenderer: (params) => (
    //     <SecondaryButton
    //       className="reject-btn d-flex  justify-content-center align-items-center"
    //       onClick={() => onClickReject(params)}
    //     >
    //       Cancel
    //     </SecondaryButton> //WE NEED TO WRITE THE LOGIC FOR THIS ONE ACCORDINGLY WHICH HAS TO BE SHOWN FOR ADMIN ITSELF
    //   ),
    // },
  ];

  const defaultColDef = useMemo(() => {
    return {
      cellStyle: { fontSize: "14px" },
    };
  }, []);

  const paginationPageSize = 20;

  const onClickRetry = () => {
    getLeavesReqData();
  };

  const leaveRequestsPage = () => (
    <>
      <div
        className="ag-theme-alpine"
        style={{
          height: "70vh",
          // width: "85vw",
          fontSize: "14px",
          marginLeft: "15px",
          marginRight: "15px",

          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        {/* <h4 className="mb-3 mt-3">Leave Requests</h4> */}

        <AgGridReact
          rowData={leavesReqData}
          columnDefs={pendingLeavescolumns}
          pagination={true}
          paginationPageSize={paginationPageSize}
          defaultColDef={defaultColDef}
          enableCellTextSelection={true}
        ></AgGridReact>
      </div>
    </>
  );

  const renderLeaveRequests = () => {
    switch (apiStatus) {
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      case apiStatusConstants.success:
        return leaveRequestsPage();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={onClickRetry} />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="d-flex flex-row flex-wrap justify-content-end align-items-center mb-1">
        <div className="month-picker d-flex flex-column m-1">
          <label className="mb-1 ">Start Month</label>
          <DatePicker
            className="date-input-label"
            selected={startMonth}
            onChange={(date) => {
              if (date) {
                setStartMonth(date);
                if (date > endMonth) {
                  setEndMonth(date);
                }
              } else {
                setStartMonth(new Date());
              }
            }}
            showMonthYearPicker
            dateFormat="MMMM yyyy"
          />
        </div>
        <div className="month-picker d-flex flex-column m-1">
          <label className="mb-1 ">End Month</label>
          <DatePicker
            className="date-input-label"
            selected={endMonth}
            onChange={(date) => {
              if (date) {
                setEndMonth(date);
              } else {
                setEndMonth(new Date());
              }
            }}
            showMonthYearPicker
            dateFormat="MMMM yyyy"
            minDate={startMonth}
          />
        </div>
      </div>
      {renderLeaveRequests()}
      {/* <SlidingModal
        modalName="Leave Reject"
        closeBtn={onClickClose}
        isModalOpen={rejectClicked}
      >
        <LeaveRejectForm
          rowData={rowData}
          getLeavesReqData={getLeavesReqData}
          setReject={setReject}
          setRowData={setRowData}
          closeBtn={onClickClose}
        />
      </SlidingModal> */}

      <PopupModal
        modalName="Reject Leave Request"
        closeBtn={onClickClose}
        showModal={rejectClicked}
        mb ="mb-2"
        paddingTop="18px"
      >
        <LeaveRejectForm
          rowData={rowData}
          getLeavesReqData={getLeavesReqData}
          setReject={setReject}
          setRowData={setRowData}
          closeBtn={onClickClose}
          notifyRejected={notifyRejected}
        />
      </PopupModal>

    </>
  );
};

export default LeaveRequestsRoute;
